// 图层状态管理
var layerExistList = []
function getExistLayerList () {
  return layerExistList
}
// 校验当前图层是否存在
function checkLayerExist (params, self) {
  self = self || this
  var isExist = false
  layerExistList.forEach(layer => {
    //
    if (params.id === layer.info.id) {
      isExist = true
    }
  })
  return isExist
}

// 添加 图层 存在状态
function addLayerExist (info) {
  layerExistList.push(info)
  layerExistList.sort((a, b) => {
    if (a.info.zIndex === b.info.zIndex) {
      return 0
    }
    if (a.info.zIndex < b.info.zIndex) {
      return -1
    }
    return 1
  })
}

function getLayerExist (info) {
  let addedLayer = null
  for (let i = 0; i < layerExistList.length; i++) {
    const layer = layerExistList[i]
    //
    if (info.id === layer.info.id) {
      addedLayer = layer
      // layerIndex = i
    }
  }
  return addedLayer
}

// 移除 图层 存在状态
function removerLayerExist (params) {
  layerExistList = layerExistList.filter((item) => {
    return item.info.id !== params.id
  })
}

export {
  checkLayerExist,
  addLayerExist,
  getLayerExist,
  removerLayerExist,
  getExistLayerList
}
